import "@lds/core/lds-select.js"
import "@lds/core/lds-option.js"
import "@lds/core/lds-dropdown.js"

import "./saved-items/generation.ts"
import "./saved-items/removeSavedSearches.ts"

import "@modules/banner/donnerstag/header-donnerstag-mobile.css"
import "@modules/banner/donnerstag/footer-donnerstag-mobile.css"
import "@modules/banner/mittwoch/header-mittwoch-mobile.css"
import "@modules/banner/mittwoch/footer-mittwoch-mobile.css"
import "@modules/banner/muenchen/muenchen-messe-mobile.css"
import "@modules/banner/muenchen/muenchen-valentines-mobile.css"
import "@modules/banner/muenchen/muenchen-wiesn-mobile.css"
import "@modules/banner/city-highlight/city-highlight"
import "@modules/banner/city-highlight/header-city-highlight-mobile.css"

import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
